<template>
  <div class="rcs-step rcs-step--intro">
    <h2 class="rcs-step__heading">
      {{ t('storeParameters.services.rcsServiceParameter.welcome.title') }}
    </h2>
    <p class="rcs-step__lead">
      {{ t('storeParameters.services.rcsServiceParameter.welcome.subtitle') }}
    </p>
    <h3 class="rcs-step__subheading">
      {{ t('storeParameters.services.rcsServiceParameter.welcome.benefitsTitle') }}
    </h3>
    <ul class="rcs-step__benefits">
      <li
        v-for="(key, index) in benefitKeys"
        :key="index"
      >
        <i class="fa-solid fa-check-circle" />
        <span>{{ t(key) }}</span>
      </li>
    </ul>
    <div
      class="rcs-step__alert"
      role="note"
    >
      <i class="fa-solid fa-circle-info" />
      <span>{{ t('storeParameters.services.rcsServiceParameter.welcome.note') }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'RcsWelcomeStep',

  setup() {
    const { t } = useI18n();
    const benefitKeys = [
      'storeParameters.services.rcsServiceParameter.welcome.benefit1',
      'storeParameters.services.rcsServiceParameter.welcome.benefit2',
      'storeParameters.services.rcsServiceParameter.welcome.benefit3',
      'storeParameters.services.rcsServiceParameter.welcome.benefit4',
    ];
    return { t, benefitKeys };
  },
});
</script>
